import InputSelect from "./InputSelect";

export default function FormInputSelect({
    label,
    options,
    required,
    value,
    onChange,
    name="",
    placeholder,
    showPlaceholder = true,
    labelRequire = false,
    colorSelect="black",
    colorBackgroundInput="transparent",
    colorOption="black"
}) {

    return (
        <InputSelect 
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            required={required}
            labelRequire={labelRequire}
            placeholder={placeholder}
            showPlaceholder={showPlaceholder}
            name={name}
            colorSelect={colorSelect}
            colorBackgroundInput={colorBackgroundInput}
            colorOption={colorOption}
        />
    )
}
